import type { IconNode } from '../types';

/**
 * @name card-sd
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAyMmEyIDIgMCAwIDEtMi0yVjZsNC00aDEwYTIgMiAwIDAgMSAyIDJ2MTZhMiAyIDAgMCAxLTIgMloiIC8+CiAgPHBhdGggZD0iTTggMTBWNy41IiAvPgogIDxwYXRoIGQ9Ik0xMiA2djQiIC8+CiAgPHBhdGggZD0iTTE2IDZ2NCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/card-sd
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cardSd: IconNode = [
  ['path', { d: 'M6 22a2 2 0 0 1-2-2V6l4-4h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2Z', key: '6al2kf' }],
  ['path', { d: 'M8 10V7.5', key: '73qd2s' }],
  ['path', { d: 'M12 6v4', key: '16clxf' }],
  ['path', { d: 'M16 6v4', key: '14ug32' }],
];

export default cardSd;
